import { ACTIVATION_SELECT_ENABLE } from "./ItemMyStatBase"


export const TITLE_league_id = '歸屬球隊'
export const TITLE_player_number = '背號'
export const TITLE_team_duration_start = '起始日期'
export const TITLE_team_duration_end = '結束日期'
export const TITLE_player_description = '描述'


export const PLAYER_CURRENTLY_HISTORY = 0
export const PLAYER_CURRENTLY_NOW = 1

export const PLAYER_CURRENTLY_HISTORY_STRING = '歷史紀錄'
export const PLAYER_CURRENTLY_NOW_STRING = '目前所屬球隊'


export function get_player_description_string(val) {
    switch (val) {
        case PLAYER_CURRENTLY_HISTORY:
            return PLAYER_CURRENTLY_HISTORY_STRING
        case PLAYER_CURRENTLY_NOW:
            return PLAYER_CURRENTLY_NOW_STRING
        default:
            return ""
    }
}



export class ReqPlayerHistoryList {
    constructor({ player_id = "" }) {
        this.player_id = player_id
    }

    fromJson(jsonData) {
        this.player_id = jsonData.player_id || ""
    }
}

export class RespPlayerHistory {
    constructor({
        player_history_id = "",
        league_id, 
        team_id = "",
        team_history_id = "",
        player_id, 
        player_number = "",
        team_duration_start=null,
        team_duration_end=null,
        player_description = "",
        player_currently = PLAYER_CURRENTLY_HISTORY
    }) {
        this.player_history_id = player_history_id
        this.league_id = league_id
        this.team_id = team_id
        this.team_history_id =team_history_id
        this.player_id = player_id
        this.player_number = player_number
        this.team_duration_start = team_duration_start
        this.team_duration_end = team_duration_end
        this.player_description = player_description
        this.player_currently = player_currently
    }

    fromJson(jsonData) {
        this.player_history_id = jsonData.player_history_id
        this.league_id = jsonData.league_id
        this.team_id = jsonData.team_id
        this.team_history_id = jsonData.team_history_id
        this.player_id = jsonData.player_id
        this.player_number = jsonData.player_number
        this.team_duration_start = jsonData.team_duration_start
        this.team_duration_end = jsonData.team_duration_end
        this.player_description = jsonData.player_description
        this.player_currently = jsonData.player_currently
    }
}